
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import { filter, commonApi } from '@/common/index';
import BScroll from 'better-scroll';
import { mapState, mapMutations } from 'vuex';
import { msgTypeOptions, resetTextBylangKey } from '../../../libs/options.js'
export default {
name: 'sendEmail',
components: { Group, XInput, XTextarea, XButton, Picker, XDialog },
data() {
return {
main: '',//主题
textarea: '',//留言
infoType: [''],
showToast: false
}
},
computed: {
...mapState({ UUID: state => state.UUID }),
msgTypeLists() {
return [resetTextBylangKey(msgTypeOptions, this.$t('mine').stationLetter.msgTypeOptions, 'name')]
},
infoTypeName() {
if (this.infoType[0] === '') return ''
if (this.infoType[0] !== '') return (this.msgTypeLists[0].filter((item) => (item.value === this.infoType[0])))[0]['name']
}
},
watch: {
showToast(val) {
if (val) {
if (this.infoType[0] == '') {
this.infoType.splice(0, 1, '0')
}
}
}
},
methods: {
...mapMutations(['set_bottom']),
haveComToast(data,istype){
this.$vux.toast.show({ text: data, type: istype });
},
_msgTypeChange(v) { // 变化

},
insertMsgSite() {
if (this.infoType[0] == '') {
this.haveComToast(this.$t('mine').stationLetter.selectMsgType,'cancel')
return
}
if (this.main.trim() == '') {
this.haveComToast(this.$t('mine').stationLetter.themePlace,'cancel')
return
}
if (this.textarea.trim() == '') {
this.haveComToast(this.$t('mine').stationLetter.descPlace, 'cancel')
return
}
let params = {
UUID: this.UUID,
title: this.main,
msgType: this.infoType[0],
content: this.textarea
};
commonApi.VIP.insertMsgSite(params).then(res => {
this.main = '';
this.textarea = '';
this.infoType.splice(0, 1, '')
this.haveComToast(this.$t('mine').stationLetter.sendSuccess,'text')
}).catch(err => {
this.haveComToast(err,'cancel')
});
}
}
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/StationLetter/sendMessage.vue